import { useEffect } from 'react';

import { FlagType } from '~/flags/flags';
import { useFlag } from '~/flags/useFlag';
import { User } from '~/types/User';

import { initCandu, loadCanduScript } from './setupCandu';

export const useCandu = (user: User) => {
  const enableCandu = useFlag(FlagType.CanduScript);

  useEffect(() => {
    if (enableCandu && user) {
      loadCanduScript().then(() => {
        initCandu(user);
      });
    } else {
      return;
    }
  }, [user, enableCandu]);
};
